import { cn } from '@/lib/utils'
import {
  OVERDUE_TIER_LABELS,
  OVERDUE_TIER_COLORS,
} from '@/lib/fundraising-labels'

interface OverdueTier {
  value: string
  label: string
  days_overdue: number
}

interface OverdueBadgeProps {
  tier: OverdueTier
  className?: string
}

export function OverdueBadge({ tier, className }: OverdueBadgeProps) {
  const colorClass = OVERDUE_TIER_COLORS[tier.value] ?? ''
  const label = OVERDUE_TIER_LABELS[tier.value] ?? tier.label

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        colorClass,
        className
      )}
      title={`${tier.days_overdue} jour(s) de retard`}
    >
      {label}
    </span>
  )
}
